import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Breadcrumb = () => {
  const location = useLocation();
  
  // Split the pathname into an array of paths
  const paths = location.pathname.split('/').filter((path) => path);

  return (
    <nav aria-label="breadcrumb">
      <ul className="breadcrumb">
        <li className="breadcrumb-item">
          <Link className="home-url" to="/"><i className="ri-home-4-line"></i></Link>
          <span className="separator">
            <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1.42462L8 8.42462L1 15.4246" stroke="black" stroke-width="1.6"/>
            </svg>
          </span>
        </li>
        {paths.map((path, index) => {
          const url = `/${paths.slice(0, index + 1).join('/')}`;
          const isLast = index === paths.length - 1;

          return isLast ? (
            <li className="breadcrumb-item active" aria-current="page" key={index}>
              {path}
            </li>
          ) : (
            <li className="breadcrumb-item" key={index}>
              <Link to={url}>{path}</Link>
              <span className="separator">
                <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1.42462L8 8.42462L1 15.4246" stroke="black" stroke-width="1.6"/>
            </svg>
              </span>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Breadcrumb;
